module.exports = __webpack_public_path__ + "static/img/sbgk-title.251571b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/xiayan/assets/img/sbgk-title.png
// module id = jCSn
// module chunks = 1